import React from "react";

const DPA = () => {
  return (
    <div className="max-w-4xl mx-auto px-6 py-10">
      <h1 className="text-3xl font-bold text-center mb-8">
        Data Protection Addendum (DPA)
      </h1>
      <p className="text-gray-700 mb-4">Last Updated: 12/29/2024</p>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">1. Definitions</h2>
        <p className="mb-2">
          Any capitalized terms not defined herein have the meanings set forth
          in the Underlying Agreement(s) or applicable Data Protection Laws.
        </p>
        <ul className="list-disc ml-6">
          <li className="mb-2">
            <strong>"Data Breach"</strong>: A confirmed incident leading to
            accidental or unlawful destruction, loss, alteration, unauthorized
            disclosure of, or access to Personal Information processed by
            Recovery House Platform.
          </li>
          <li className="mb-2">
            <strong>"Data Protection Laws"</strong>: Applicable privacy and data
            protection laws, such as the California Consumer Privacy Act (CCPA)
            and California Privacy Rights Act (CPRA).
          </li>
          <li className="mb-2">
            <strong>"Personal Information"</strong>: Information relating to an
            identified or identifiable individual as defined under applicable
            Data Protection Laws.
          </li>
          <li className="mb-2">
            <strong>"Processing"</strong>: Any operation performed on Personal
            Information, including collection, use, storage, or disposal.
          </li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">
          2. Processing of Personal Information
        </h2>
        <ul className="list-disc ml-6">
          <li className="mb-2">
            <strong>Service Provider Role:</strong> Recovery House Platform acts
            as a Service Provider processing Personal Information solely on
            behalf of the Customer and under the Customer’s instructions.
          </li>
          <li className="mb-2">
            <strong>Purpose Limitation:</strong> Personal Information will only
            be processed as necessary to perform the agreed-upon services.
          </li>
          <li className="mb-2">
            <strong>Prohibited Uses:</strong> Recovery House Platform will not
            sell or use Personal Information for any purpose outside the
            business relationship with the Customer.
          </li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">3. Security Measures</h2>
        <p>
          Recovery House Platform will implement appropriate technical and
          organizational measures to ensure the security and confidentiality of
          Personal Information, including:
        </p>
        <ul className="list-disc ml-6">
          <li className="mb-2">
            Access controls to restrict unauthorized access.
          </li>
          <li className="mb-2">Encryption and secure storage protocols.</li>
          <li className="mb-2">Regular security audits and monitoring.</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">
          4. Data Breach Notification
        </h2>
        <p>
          In the event of a confirmed Data Breach involving Personal
          Information, Recovery House Platform will:
        </p>
        <ul className="list-disc ml-6">
          <li className="mb-2">
            Notify the Customer without undue delay, but no later than 72 hours
            after becoming aware of the breach.
          </li>
          <li className="mb-2">
            Provide sufficient details to allow the Customer to meet any
            regulatory obligations.
          </li>
          <li className="mb-2">
            Cooperate with the Customer to mitigate any adverse effects of the
            breach.
          </li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">
          5. Retention and Deletion
        </h2>
        <ul className="list-disc ml-6">
          <li className="mb-2">
            Recovery House Platform will retain Personal Information only as
            long as necessary to provide the services or comply with legal
            obligations.
          </li>
          <li className="mb-2">
            Upon termination of services or at the Customer’s request, Recovery
            House Platform will delete or return Personal Information, except
            where retention is required by law.
          </li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">7. Miscellaneous</h2>
        <p>
          This DPA prevails over conflicting terms in the Underlying
          Agreement(s) concerning data protection. If any provision of this DPA
          is found to be unenforceable, the remaining provisions will remain in
          full force and effect.
        </p>
      </section>

      <p className="text-gray-600 text-sm">
        By using Recovery House Platform, the Customer agrees to the terms of
        this Data Protection Addendum.
      </p>
    </div>
  );
};

export default DPA;
